import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const AdminLoading: TOC<Signature> = <template>{{outlet}}</template>;

export default AdminLoading;
